import * as React from "react";
import * as Immutable from "immutable";
import compact from "lodash/compact";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { loadUsersPaginated } from "hooks/useUsers";
import { Button } from "components/bootstrap";
import { Select } from "components/common";
const SubmitButton = styled(Button)`
  margin-left: 15px;
`;
const FormElements = styled.div`
  display: flex;
`;
const SelectOption = styled.div`
  display: flex;
  align-items: center;
`;
const StyledSelect = styled(Select)`
  flex: 1;
`;
const _renderOption = ({ label }) => /* @__PURE__ */ React.createElement(SelectOption, null, label);
const _options = (users, team) => users.filter((u) => !team.users.includes(u.id)).toArray().map((u) => ({ label: u.name, value: u.id }));
const _assignUser = (teamName, selectedUserIds, users, onSubmit, setSelectedUserIds, setIsSubmitting) => {
  var _a;
  if (!selectedUserIds) {
    return;
  }
  const selectedUsers = compact(
    selectedUserIds.split(",").map((selectedUserId) => users.find((u) => u.id === selectedUserId))
  );
  if (!selectedUsers) {
    throw new Error(
      `User assignment team ${teamName} failed, because users with ids ${(_a = selectedUserIds.join(",")) != null ? _a : "(undefined)"} does not exist in ${users.map((u) => u.username).join(", ")}`
    );
  }
  onSubmit(Immutable.Set(selectedUsers)).then(() => {
    setSelectedUserIds();
    setIsSubmitting(false);
  });
};
const UsersSelector = ({ team, onSubmit }) => {
  const [users, setUsers] = useState(Immutable.List());
  const [selectedUserIds, setSelectedUserIds] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const _onSubmit = () => _assignUser(team.name, selectedUserIds, users, onSubmit, setSelectedUserIds, setIsSubmitting);
  const options = _options(users, team);
  useEffect(() => {
    const getUnlimited = { page: 1, perPage: 0, query: "" };
    loadUsersPaginated(getUnlimited).then(({ list }) => setUsers(list));
  }, [team]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FormElements, null, /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      onChange: setSelectedUserIds,
      optionRenderer: _renderOption,
      options,
      multi: true,
      placeholder: "Search for users",
      value: selectedUserIds
    }
  ), /* @__PURE__ */ React.createElement(
    SubmitButton,
    {
      bsStyle: "primary",
      disabled: isSubmitting || !selectedUserIds,
      onClick: _onSubmit,
      title: "Assign User",
      type: "button"
    },
    "Assign User"
  )));
};
export default UsersSelector;
